jQuery(".search-nav").click( function() {
    jQuery(".search-form-header").toggleClass("open");
})